<template>
  <div class="page">
    <h1>Kontakt</h1>
    <p>TODO</p>
  </div>
</template>

<script>
export default {
  data:()=>({name:'',email:'',msg:''}),
  methods:{
    async submit(){
      alert('Danke! (Formular-Handling im Backend wäre der nächste Schritt.)')
    }
  }
}
</script>

<style scoped>
.page{max-width:900px;margin:40px auto;padding:0 16px;color:#fff}
form{display:flex;flex-direction:column;gap:8px;margin-top:12px}
input,textarea{padding:10px;border-radius:6px;border:1px solid #333;background:#111;color:#fff}
button{padding:10px;border-radius:6px;border:0;background:#00aeff;color:#fff;cursor:pointer}
button:hover{background:#008dd1}
</style>
